import { ReactNode } from 'react'
import { Box, Typography } from '@mui/material'

interface ProfileFieldProps {
  label: string
  value: ReactNode
}

/** A read-only label/value row for profile read views. */
export const ProfileField = ({ label, value }: ProfileFieldProps) => (
  <Box sx={{ mb: 2 }}>
    <Typography variant="body2" color="text.secondary">
      {label}
    </Typography>
    <Typography variant="body1" sx={{ fontWeight: 500 }}>
      {value || value === 0 ? value : '—'}
    </Typography>
  </Box>
)
